import { memo } from "react";

import { QuestionConnection as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import { usePlanAvailableRoomIDs } from "./hooks";

export const QuestionPlanRoomConnection = memo(() => {
	const { availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs } =
		usePlanAvailableRoomIDs();

	const title = "予約可能な部屋";
	const guide = "このプランで予約可能な部屋を選択しましょう";

	return (
		<Question
			title={title}
			guide={guide}
			required={true}
			availableItemIDs={availableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
		/>
	);
});

QuestionPlanRoomConnection.displayName = "QuestionPlanRoomConnection";
